import {
  DOCTOR_AVAILABILITIES_CLEAR,
  DOCTOR_AVAILABILITIES_CREATE,
  DOCTOR_AVAILABILITIES_DELETE,
  DOCTOR_AVAILABILITIES_FETCH,
  DOCTOR_AVAILABILITIES_FETCH_FOR_OFFICE,
  DOCTOR_CREATE,
  DOCTOR_EDIT,
  DOCTOR_DELETE,
  DOCTOR_LIST_FETCH,
  DOCTOR_LIST_FETCH_FOR_OFFICE
} from '../constants/doctorTypes';

export function doctorAvailabilitiesClear() {
  return {
    type: DOCTOR_AVAILABILITIES_CLEAR
  };
}

export function doctorAvailabilitiesCreate(params) {
  return {
    type: DOCTOR_AVAILABILITIES_CREATE,
    payload: params
  };
}

export function doctorAvailabilitiesDelete(params) {
  return {
    type: DOCTOR_AVAILABILITIES_DELETE,
    payload: params
  };
}

export function doctorAvailabilitiesFetch(params) {
  return {
    type: DOCTOR_AVAILABILITIES_FETCH,
    payload: params
  };
}

export function doctorAvailabilitiesFetchForOffice(params) {
  return {
    type: DOCTOR_AVAILABILITIES_FETCH_FOR_OFFICE,
    payload: params
  };
}

export function doctorCreate(params) {
  return {
    type: DOCTOR_CREATE,
    payload: params
  };
}

export function doctorEdit(params) {
  return {
    type: DOCTOR_EDIT,
    payload: params
  };
}

export function doctorDelete(params) {
  return {
    type: DOCTOR_DELETE,
    payload: params
  };
}

export function doctorListFetch(params) {
  return {
    type: DOCTOR_LIST_FETCH,
    payload: params
  };
}

export function doctorListFetchForOffice(params) {
  return {
    type: DOCTOR_LIST_FETCH_FOR_OFFICE,
    payload: params
  };
}



// WEBPACK FOOTER //
// ./app/actions/doctorActions.js